import DeviceServiceClient from "../proto/generated/scavenger_grpc_web_pb";
import proto from "../proto/generated/scavenger_pb_formatted";
import { $auth } from "../main";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
let meta = {};
const tenant = ($auth && $auth.user[tenant_key] && $auth.user[tenant_key]["tenant"]) || "";

const token = localStorage.getItem("access_token");
if (token) {
  meta = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
    Tenant: tenant,
    "Grpc-Encoding": "gzip",
  };
}

const NotificationService = new DeviceServiceClient.NotificationServiceClient(process.env["VUE_APP_ROOT_API_GRPC"], null);
export const notification_grpc_services = {
    getMeta() {
        const tenant = ($auth && $auth.user && $auth.user[tenant_key] && $auth.user[tenant_key]["tenant"]) || "";
        return tenant
      },
    GetScvRealTimeEventsStream() {
        let params = new proto.Empty();
        if(!meta.Tenant){
          meta.Tenant = this.getMeta();
        }
        const stream = NotificationService.getScvRealTimeEvents(params, meta);
        return stream;
    },
    GetScvRealTimeAlertsStream() {
      let params = new proto.Empty();
      if(!meta.Tenant){
        meta.Tenant = this.getMeta();
      }
      const stream = NotificationService.getScvRealTimeAlerts(params, meta);
      return stream;
  },
};
